/* Keep Dawn's option, media, cart and app events as the source of truth. */
(() => {
  if (window.howProductPresentation) return;
  window.howProductPresentation = true;
  const cleanup = new WeakMap();
  function enhance(root) {
    if (!root?.matches('.how-product')) return;
    cleanup.get(root)?.();
    const bar = root.querySelector('[data-how-mobile-buy]');
    const trigger = bar?.querySelector('[data-how-mobile-submit]');
    const actual = root.querySelector('product-form [type="submit"]');
    const price = root.querySelector('[id^="price-"]');
    if (!bar || !trigger || !actual) return;
    const update = () => {
      trigger.disabled = actual.disabled || actual.getAttribute('aria-disabled') === 'true';
      trigger.textContent = actual.querySelector('span')?.textContent.trim() || actual.textContent.trim();
      const priceRoot = price?.querySelector('.price');
      const current = priceRoot?.classList.contains('price--on-sale')
        ? priceRoot.querySelector('.price__sale .price-item--sale')
        : priceRoot?.querySelector('.price__regular .price-item--regular');
      bar.querySelector('[data-how-mobile-price]').textContent = current?.textContent.trim() || '';
    };
    const onClick = () => {
      if (!actual.disabled && actual.getAttribute('aria-disabled') !== 'true') actual.click();
      else actual.focus();
    };
    trigger.addEventListener('click', onClick);
    const observer = new MutationObserver(update);
    observer.observe(actual, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled']});
    if (price) observer.observe(price, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class']});
    const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {bar.hidden = entries[0].isIntersecting;},{threshold:.3}) : null;
    visibility?.observe(actual);
    cleanup.set(root, () => {observer.disconnect();visibility?.disconnect();trigger.removeEventListener('click',onClick)});
    update();
  }
  const scan = node => {
    if (node instanceof Element && node.matches('.how-product')) enhance(node);
    node.querySelectorAll?.('.how-product').forEach(enhance);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});
  else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('product-info:loaded',event=>enhance(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll?.('.how-product').forEach(root=>cleanup.get(root)?.()));
})();
